import NextLink from 'next/link';
import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import Anchor from 'components/Anchor';
import Image from 'components/Image';

import { isUrlValidForInternalUsage } from 'lib/string';

import APP from 'constants/app';

const LandingImage = ({ description, image, mobileImage, url, onClick }) => {
  const ImageComponent = (
    <Image
      alt={`banner da ${description}`}
      className={twJoin(
        'object-cover md:h-[286px] md:w-full',
        'mx-auto w-screen-sm items-center justify-center lg:w-[1264px]',
        mobileImage ? 'flex' : 'hidden lg:flex'
      )}
      height={185}
      loading={null}
      sizes={
        mobileImage
          ? '(max-width: 768px) 1px, 1264px'
          : '(max-width: 1024px) 0px, 1264px'
      }
      src={image}
      srcSet={
        mobileImage
          ? `${mobileImage} 360w, ${image} 1264w`
          : `${APP.LOCAL_IMAGE_PATH}/general/placeholder.jpg 1w, ${image} 1264w`
      }
      width={370}
      priority
      onClick={onClick}
    />
  );

  if (!url) {
    return ImageComponent;
  }

  if (!isUrlValidForInternalUsage(url)) {
    return (
      <Anchor
        className={twJoin(
          'mx-auto w-screen-sm items-center justify-center lg:w-[1264px]',
          mobileImage ? 'flex' : 'hidden lg:flex'
        )}
        href={url}
        rel="noopener noreferrer"
        target="_blank"
        onClick={onClick}
      >
        {ImageComponent}
      </Anchor>
    );
  }

  return (
    <NextLink href={url} passHref>
      <Anchor
        className={twJoin(
          'mx-auto w-screen-sm items-center justify-center lg:w-[1264px]',
          mobileImage ? 'flex' : 'hidden lg:flex'
        )}
        onClick={onClick}
      >
        {ImageComponent}
      </Anchor>
    </NextLink>
  );
};

LandingImage.propTypes = {
  description: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  mobileImage: PropTypes.string,
  url: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default LandingImage;
